import { useEffect, useMemo, useState } from "react"
import { Input, Button, Table, Select, DatePicker, Space, Radio, Form } from 'antd'
import Modal from "antd/lib/modal/Modal"
import TextArea from "antd/lib/input/TextArea"
import { RadioChangeEvent } from "antd/lib/radio/interface"
import { SearchOutlined, RedoOutlined } from '@ant-design/icons'
import { axiosTable, baseAxiosComplete, baseAxiosNoInfo } from '../../tool/axios'
import { SelectStores } from "../../component/common/Selects"
import BreadCrumb from '../../component/BreadCrumb'
import getPermission from '../../js/permission'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import moment from 'moment';
import _ from 'lodash'

const { Column } = Table
const { Option } = Select
const { RangePicker } = DatePicker

type fetchParams = {
    promotion_id: string | undefined
    store_id: string | undefined
    nursing_name: string | undefined
    nursing_phone: string | undefined
    promotionDay: any
    promotion_start_date: string | undefined
    promotion_end_date: string | undefined
    promotion_type: number | undefined
    review_status: number | undefined
}

type pagination = {
    current: number,
    pageSize: number,
    total: number,
    showSizeChanger: boolean
}

type empRecord = {
    employee_id: string
    user_name: string
}

type starLevelRecord = {
    star_level_id: string
    star_level_name: string
}

export default function () {

    let fetchOtherParamsTmpl: fetchParams = {
        promotion_id: undefined,
        store_id: undefined,
        nursing_name: undefined,
        nursing_phone: undefined,
        promotionDay: null,
        promotion_start_date: undefined,
        promotion_end_date: undefined,
        promotion_type: undefined,
        review_status: undefined
    }

    const [fetchOtherParams, setFetchOtherParams] = useState<fetchParams>(fetchOtherParamsTmpl)
    const [pagination, setPagination] = useState<pagination>({
        current: 1,
        pageSize: 8,
        total: 0,
        showSizeChanger: false
    })

    const [loading, setLoading] = useState<boolean>(false)
    const [data, setData] = useState<any>([])

    const [form] = Form.useForm()
    const [reviewForm] = Form.useForm()
    const [recordId, setRecordId] = useState<string>('')
    const [passType, setPassType] = useState<number | undefined>(undefined)

    const [showType, setShowType] = useState<string>('')
    const [showVisible, setShowVisible] = useState<boolean>(false)
    const [showReviewVisible, setShowReviewVisible] = useState<boolean>(false)

    const [empList, setEmpList] = useState<empRecord[]>([])
    const [starLevelList, setStarLevelList] = useState<starLevelRecord[]>([])

    const permission: string[] = useMemo(() => {
        return getPermission()
    }, [window.location.pathname])

    useEffect(() => {
        // 查询标准星级列表
        baseAxiosNoInfo.get("/yuesao_center/global/star_level_list", {

        }).then((res: any) => {
            res && setStarLevelList(res)
        })

        fetch({ pagination, fetchOtherParams })
    }, [pagination.current, pagination.pageSize])

    const handleChange = (value: any, attr: string) => {
        let params: any = _.cloneDeep(fetchOtherParams)
        params[attr] = value

        setFetchOtherParams(params)
    }

    const handleDate = (param: any, attr: string, realDateParams: string[]) => {
        if (param[attr]) {
            param[realDateParams[0]] = param[attr][0].format('YYYY-MM-DD')
            param[realDateParams[1]] = param[attr][1].format('YYYY-MM-DD')

            delete param[attr]
        }
    }

    const handleSearch = () => {
        const p = { ...pagination }
        p.current = 1

        fetch({ pagination: p, fetchOtherParams })
    }

    const handleTableChange = (antPagination: any) => {
        const p = { ...pagination }
        p.current = antPagination.current
        p.pageSize = antPagination.pageSize

        setPagination(p)
    }

    const fetch = ({ pagination, fetchOtherParams }: { pagination: Object, fetchOtherParams: object }) => {
        setLoading(true)

        const iPagination: any = { ...pagination }
        iPagination.page_num = iPagination.current
        iPagination.page_size = iPagination.pageSize

        delete iPagination.current
        delete iPagination.pageSize
        delete iPagination.total

        let params: any = { ...fetchOtherParams }
        handleDate(params, 'promotionDay', ['promotion_start_date', 'promotion_end_date'])

        axiosTable.get('/yuesao_center/manage/promotion/page_list', {
            params: {
                ...iPagination,
                ...params
            }

        }).then((response: any) => {
            if (response) {
                let p: any = { ...pagination }
                p.total = response.total

                setPagination(p)
                setData(response.records)
            }

            setLoading(false)
        })
    }

    const resetForm = () => {
        setFetchOtherParams(fetchOtherParamsTmpl)

        let p: any = { ...pagination }
        p.current = 1

        setPagination(p)
        fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })
    }

    const handleAddOrMod = (value: string) => {
        if (value) {
            setShowType('mod')

        } else {
            form.setFieldsValue({
                store_id: '',
                nursing_id: '',
                promotion_date: '',
                star_level_id: '',
                promotion_type: '',
                promotion_reason: ''
            })

            setShowType('add')
        }

        setRecordId(value)
        setShowVisible(true)
    }

    const confirmAddOrMod = (value: any) => {
        let id = recordId
        let url = id ? '/yuesao_center/manage/promotion/update' : '/yuesao_center/manage/promotion/add'

        let postData: any = {}

        if (id) {
            postData = {
                promotion_id: id,
                nursing_id: value.nursing_id,
                promotion_date: moment(value.promotion_date).format('YYYY-MM-DD'),
                star_level_id: value.star_level_id,
                promotion_type: value.promotion_type,
                promotion_reason: value.promotion_reason
            }

        } else {
            postData = {
                nursing_id: value.nursing_id,
                promotion_date: value.promotion_date.format('YYYY-MM-DD'),
                star_level_id: value.star_level_id,
                promotion_type: value.promotion_type,
                promotion_reason: value.promotion_reason
            }
        }

        baseAxiosComplete.post(url, postData).then((res: any) => {
            if (res.status === 0) {
                let p: any = { ...pagination }
                p.current = 1

                setPagination(p)
                fetch({ pagination: p, fetchOtherParams: fetchOtherParamsTmpl })

                setShowVisible(false)
            }
        })
    }

    const handlePassChange = (e: RadioChangeEvent) => {
        setPassType(e.target.value)
    }

    const confirmReview = (value: any) => {
        baseAxiosComplete.post('/yuesao_center/manage/promotion/review', {
            promotion_id: recordId,
            review_status: value.review_status,
            review_refuse_reason: value.review_refuse_reason

        }).then((res: any) => {
            if (res.status === 0) {
                fetch({ pagination, fetchOtherParams })
                setShowReviewVisible(false)
            }
        })
    }

    return (<div className="common-page">
        {/* 月嫂中心 -> 月嫂管理 -> 月嫂晋级管理 */}
        <BreadCrumb position={['月嫂中心', '月嫂晋级管理']} />

        <div className="common-top-form">
            <Space direction="horizontal" wrap>
                <div style={{ marginRight: 8, marginBottom: 12 }}>
                    <SelectStores placeholder="门店" value={fetchOtherParams.store_id} onChange={(value: string) => { handleChange(value, 'store_id') }} />
                </div>

                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工名称" value={fetchOtherParams.nursing_name} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_name') }} />
                <Input style={{ marginRight: 8, marginBottom: 12, width: '150px' }} placeholder="员工手机号" value={fetchOtherParams.nursing_phone} onChange={(e: { target: { value: string } }) => { handleChange(e.target.value, 'nursing_phone') }} />

                <RangePicker
                    className="fl"
                    style={{ marginRight: 8, marginBottom: 12, width: 250 }}
                    placeholder={["晋级开始日期", "晋级结束日期"]}
                    value={fetchOtherParams.promotionDay}
                    onChange={(v: any) => { handleChange(v, 'promotionDay') }}
                />

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="晋级类型" value={fetchOtherParams.promotion_type} onChange={(value: number) => { handleChange(value, 'promotion_type') }}  >
                    <Option value="1">常规</Option>
                    <Option value="2">破格</Option>
                </Select>

                <Select allowClear style={{ marginRight: 8, marginBottom: 12, width: 120 }} placeholder="审核状态" value={fetchOtherParams.review_status} onChange={(value: number) => { handleChange(value, 'review_status') }}  >
                    <Option value="0">待审核</Option>
                    <Option value="1">审核通过</Option>
                    <Option value="2">审核不通过</Option>
                </Select>
            </Space>

            <div style={{ marginTop: 10 }}>
                {permission.includes('查询') && <Button style={{ marginRight: 12, marginBottom: 12 }} className="search-btn" icon={<SearchOutlined />} onClick={handleSearch} >查询</Button>}
                <Button style={{ marginRight: 12, marginBottom: 12 }} onClick={resetForm} icon={<RedoOutlined />}>重置</Button>
                {permission.includes('添加') && <Button type="primary" style={{ marginRight: 12, marginBottom: 12 }} onClick={() => { handleAddOrMod('') }}>添加</Button>}
            </div>
        </div>

        <div className="common-main">
            <Table loading={loading} dataSource={data} scroll={{ x: 'max-content' }} bordered={true} rowKey="promotion_id" pagination={pagination} onChange={handleTableChange}>
                <Column
                    fixed
                    title="操作"
                    key="action"
                    render={(text, record: any) => {
                        return (<Space size="middle">
                            {record.review_status !== 1 && permission.includes('编辑') && <Button size="small" onClick={() => {
                                baseAxiosNoInfo('/yuesao_center/manage/promotion/detail', {
                                    params: {
                                        promotion_id: record.promotion_id
                                    }

                                }).then((res: any) => {
                                    res && form.setFieldsValue({
                                        nursing_id: res.nursing_id,
                                        nursing_name: res.nursing_name,
                                        promotion_date: res.promotion_date,
                                        star_level_id: res.star_level_id,
                                        promotion_type: res.promotion_type,
                                        promotion_reason: res.promotion_reason
                                    })
                                })

                                handleAddOrMod(record.promotion_id)
                            }} >编辑</Button>}

                            {record.review_status === 0 && permission.includes('审核') && <Button size="small" onClick={() => {
                                setRecordId(record.promotion_id)
                                setShowReviewVisible(true)
                            }} >审核</Button>}
                        </Space>)
                    }}
                />

                <Column fixed title="门店名称" dataIndex="store_name" key="store_name" />
                <Column fixed title="员工名称" dataIndex="nursing_name" key="nursing_name" />
                <Column fixed title="员工手机号" dataIndex="nursing_phone" key="nursing_phone" />
                <Column fixed title="晋级日期" dataIndex="promotion_date" key="promotion_date" />
                <Column title="原星级名称" dataIndex="old_star_level_name" key="old_star_level_name" />
                <Column title="新星级名称" dataIndex="new_star_level_name" key="new_star_level_name" />
                <Column title="晋级类型" dataIndex="promotion_type_desc" key="promotion_type_desc" />
                <Column title="晋级原因" dataIndex="promotion_reason" key="promotion_reason" />
                <Column title="审核状态" dataIndex="review_status_desc" key="review_status_desc" />
                <Column title="审核人" dataIndex="review_user_name" key="review_user_name" />
                <Column title="审核时间" dataIndex="review_time" key="review_time" />
                <Column title="创建人" dataIndex="create_user_name" key="create_user_name" />
                <Column title="创建时间" dataIndex="create_time" key="create_time" />
                <Column title="更新人" dataIndex="update_user_name" key="update_user_name" />
                <Column title="更新时间" dataIndex="update_time" key="update_time" />
            </Table>
        </div>

        {/* 月嫂中心 -> 月嫂管理 -> 月嫂晋级管理 -> 新增或编辑 */}
        <Modal title={showType == "add" ? "新增月嫂晋级" : "编辑月嫂晋级"} visible={showVisible} footer={false} width="500px" onCancel={() => { setShowVisible(false) }}>
            <Form {...formItemLayout} name="validate_other" form={form} onFinish={confirmAddOrMod} >
                {showType == "add" && (
                    <Form.Item label="门店" name="store_id" rules={[{ required: true, message: '必须选择门店' }]} >
                        <SelectStores onChange={((v: any) => {
                            // 查询该门店下的员工列表
                            baseAxiosNoInfo('/global/employee_list_by_position', {
                                params: {
                                    department_id: v,
                                    position_number: 21
                                }

                            }).then((res: any) => {
                                res && setEmpList(res)
                            })
                        })} />
                    </Form.Item>
                )}

                {showType == "add" && (
                    <Form.Item label="员工" name="nursing_id" rules={[{ required: true, message: '必须选择员工' }]} >
                        <Select virtual={false} showSearch filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                            {empList.map((el: any) => (<Option value={el.employee_id} key={el.employee_id}>{el.user_name}</Option>))}
                        </Select>
                    </Form.Item>
                )}

                {showType != "add" && (
                    <Form.Item label="员工" name="nursing_name">
                        <Input readOnly />
                    </Form.Item>
                )}

                <Form.Item label="晋级日期" name="promotion_date" rules={[{ required: true, message: '必须选择晋级日期' }]} getValueProps={(value) => ({ value: value ? moment(value) : null })}>
                    <DatePicker />
                </Form.Item>

                <Form.Item label="晋级星级" name="star_level_id" rules={[{ required: true, message: '必须选择晋级星级' }]} >
                    <Select virtual={false} showSearch filterOption={(input, option) => (option!.children as unknown as string).includes(input)}>
                        {starLevelList.map((el: any) => (<Option value={el.star_level_id} key={el.star_level_id}>{el.star_level_name}</Option>))}
                    </Select>
                </Form.Item>

                <Form.Item label="晋级类型" name="promotion_type" rules={[{ required: true, message: '必须选择晋级类型' }]}>
                    <Select >
                        <Option value={1} key="1">常规</Option>
                        <Option value={2} key="2">破格</Option>
                    </Select>
                </Form.Item>

                <Form.Item label="晋级原因" name="promotion_reason" rules={[{ required: true, message: '必须填写晋级原因' }]} >
                    <TextArea style={{ height: 150 }} />
                </Form.Item>

                <Form.Item {...tailLayout}>
                    <Button type="primary" htmlType="submit">提交</Button>
                </Form.Item>
            </Form>
        </Modal>

        {/* 月嫂中心 -> 月嫂管理 -> 月嫂晋级管理 -> 审核 */}
        <Modal title="审核月嫂晋级" visible={showReviewVisible} footer={false} width="400px" onCancel={() => { setShowReviewVisible(false) }}>
            <Form form={reviewForm} onFinish={confirmReview} >
                <Form.Item style={{ marginTop: 8, marginBottom: 8 }} label="是否通过" name="review_status" rules={[{ required: true, message: '必须选择是否通过审核' }]}>
                    <Radio.Group onChange={handlePassChange} value={passType}>
                        <Radio value={1}>通过</Radio>
                        <Radio value={2}>不通过</Radio>
                    </Radio.Group>
                </Form.Item>

                {passType === 2 && <Form.Item label="备注" name="review_refuse_reason" rules={[{ required: true, message: '必须填写备注' }]}>
                    <TextArea style={{ height: 80 }} />
                </Form.Item>}

                <Form.Item wrapperCol={{ span: 12, offset: 0 }}>
                    <Button type="primary" htmlType="submit">提交审核</Button>
                </Form.Item>
            </Form>
        </Modal>
    </div>)
}